import { styled } from '@mui/material';
import { Box } from '../view.box';

const StyledCard = styled(Box)(({ theme }) => ({
	width: '100%',
	height: '100%',
	overflow: 'hidden',
	position: 'relative',
	border: `1px solid ${theme.palette.divider}`,
	aspectRatio: 1 / 1,
	borderRadius: 20,
}));

const BackgroundImageLayer = styled(Box)({
	position: 'absolute',
	inset: 0,
	borderRadius: 20,
	overflow: 'hidden',
	filter: 'blur(3px)',
	'& img': {
		position: 'absolute',
		height: '100%',
		width: '155.24%',
		left: '-54.74%',
		top: 0,
		maxWidth: 'none',
		filter: 'grayscale(100%)',
	},
});

const ColorOverlay = styled(Box, { shouldForwardProp: prop => prop !== 'backgroundColor' })<{
	backgroundColor: string;
}>(props => ({
	position: 'absolute',
	inset: 0,
	backgroundColor: props.backgroundColor,
	mixBlendMode: 'hard-light',
	borderRadius: 20,
}));

export const PromotionColorPreview = ({ color }: { color: string }) => {
	return (
		<StyledCard>
			<BackgroundImageLayer>
				<img alt="promo-bg" src="/img/promo-bg.jpg" />
			</BackgroundImageLayer>

			<ColorOverlay backgroundColor={color} />
		</StyledCard>
	);
};
